import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, sendPasswordResetEmail } from "../firebase";
import "../css/Reset.css";
function Reset() {
const [email, setEmail] = useState("");
const [submitting, setSubmitting] = useState(false);
const [message, setMessage] = useState("");
const [error, setError] = useState("");
const [user, loading] = useAuthState(auth);
const navigate = useNavigate();
useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
}, [user, loading, navigate]);

const handleReset = async (event) => {
    event.preventDefault();
    const normalizedEmail = email.trim();
    setMessage("");
    setError("");

    if (!normalizedEmail) {
        setError("Ingresá tu correo electrónico.");
        return;
    }

    setSubmitting(true);
    try {
        await sendPasswordResetEmail(auth, normalizedEmail);
        setMessage("Si el correo está registrado, recibirás un enlace para restablecer la contraseña.");
    } catch (resetError) {
        console.error("No se pudo solicitar el restablecimiento de contraseña:", resetError);
        setError("No pudimos enviar el correo. Verificá la dirección e intentá nuevamente.");
    } finally {
        setSubmitting(false);
    }
};
return (
    <div className="reset">
    <form className="reset__container" onSubmit={handleReset}>
        <input
        type="email"
        className="reset__textBox"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="E-mail Address"
        autoComplete="email"
        disabled={submitting}
        />
        <button
        type="submit"
        className="reset__btn"
        disabled={submitting}
        >
        {submitting ? "Enviando…" : "Send password reset email"}
        </button>
        {message && <p role="status">{message}</p>}
        {error && <p role="alert">{error}</p>}
        {/* <div>
        Don't have an account? <Link to="/register">Register</Link> now.
        </div> */}
    </form>
    </div>
);
}
export default Reset;
